import { ENTITY_LABEL } from "../../../Components/Helpers/Labels/EntityLabel";
import { uuidv4 } from "../../../Hooks/Display/utils";
import { initialState } from "./ComponentPropertiesContext";
import * as ComponentsPropertiesEvents from "./ComponentsPropertiesEvents";
import { addColumn, dropColumnInDifferentSection, dropColumnInSameSection, moveSectionDown, moveSectionUp, removeColumn, resizeColumns, toggleColumnColorFormatting, toggleColumnHyperlink, updateAction, updateColumnSettings } from "./utils";

export default function componentPropertiesReducer(state, action) {
    switch (action.type) {
        case ComponentsPropertiesEvents.UPDATE_GENERAL_PROPERTY:
            return {
                ...state,
                generalProperties: {
                    ...state.generalProperties,
                    [action.payload.property]: action.payload.value
                }
            };
        case ComponentsPropertiesEvents.UPDATE_CHANGE_TRACK_PROPERTY:
            return {
                ...state,
                changeTrack: {
                    ...state.changeTrack,
                    [action.payload.property]: action.payload.value
                }
            };
        case ComponentsPropertiesEvents.UPDATE_FETCHED_VALUE:
            return {
                ...state,
                fetchedValues: {
                    ...state.fetchedValues,
                    [action.payload.key]: {
                        ...state.fetchedValues[action.payload.key],
                        [action.payload.property]: action.payload.value
                    }
                }
            };
        case ComponentsPropertiesEvents.UPDATE_GENERAL_FETCHED_VALUE:
            return {
                ...state,
                fetchedValues: {
                    ...state.fetchedValues,
                    generalProperties: {
                        ...state.fetchedValues.generalProperties,
                        [action.payload.property]: action.payload.value
                    }
                }
            }
        case ComponentsPropertiesEvents.UPDATE_ATTRIBUTE_TABLE_FETCHED_VALUE:
            return {
                ...state,
                fetchedValues: {
                    ...state.fetchedValues,
                    attributeTable: {
                        ...state.fetchedValues.attributeTable,
                        [action.payload.property]: action.payload.value
                    }
                }
            };
        case ComponentsPropertiesEvents.UPDATE_ACTION_TABLE_FETCHED_VALUE:
            return {
                ...state,
                fetchedValues: {
                    ...state.fetchedValues,
                    actionTable: {
                        ...state.fetchedValues.actionTable,
                        [action.payload.property]: action.payload.value
                    }
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_CREATE_ACTION_DIALOG:
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    showCreateActionDialog: !state.actionTable.showCreateActionDialog,
                    newActionParentId: !state.actionTable.showCreateActionDialog ? action.payload : ""
                }
            };
        case ComponentsPropertiesEvents.ADD_NEW_ACTION:
            const existingAction = state.actionTable.actions.find(stateAction => stateAction.id === action.payload.parentId);
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    actions:
                        existingAction ?
                            state.actionTable.actions.map(stateAction => {
                                if (stateAction.id === action.payload.parentId) {
                                    return {
                                        ...stateAction,
                                        actions: [
                                            ...stateAction.actions,
                                            {
                                                ...action.payload,
                                                expanded: true
                                            }
                                        ]
                                    };
                                }
                                return stateAction;
                            })
                            :
                            [
                                ...state.actionTable.actions,
                                action.payload
                            ]
                }
            };
        case ComponentsPropertiesEvents.SET_ACTION_TABLE_ACTIONS:
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    actions: action.payload.map(action => ({
                        ...action,
                        expanded: true,
                        actions: action.actions ? action.actions.map(childAction => ({
                            ...childAction,
                        })) : action.actions
                    })),
                    isInitialized: true
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_EXPAND_ACTION:
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    actions: state.actionTable.actions.map(stateAction => {
                        if (stateAction.id === action.payload) {
                            return {
                                ...stateAction,
                                expanded: !stateAction.expanded
                            };
                        }
                        return stateAction;
                    })
                }
            };
        case ComponentsPropertiesEvents.DELETE_ACTION:
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    actions: state.actionTable.actions.filter(stateAction => stateAction.id !== action.payload).map(stateAction => {
                        if (stateAction.actions && stateAction.actions.length > 0) {
                            return {
                                ...stateAction,
                                actions: stateAction.actions.filter(childAction => childAction.id !== action.payload)
                            }
                        }
                        return stateAction;
                    })
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_UPDATE_ACTION_DIALOG:
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    showUpdateActionDialog: !state.actionTable.showUpdateActionDialog,
                    updateActionId: !state.actionTable.showUpdateActionDialog ? action.payload : ""
                }
            };
        case ComponentsPropertiesEvents.UPDATE_ACTION:
            debugger
            const updatedActions = updateAction(
                action.payload.id, action.payload.properties, state.actionTable.actions
            )
            return {
                ...state,
                actionTable: {
                    ...state.actionTable,
                    actions: updatedActions
                }
            };
        case ComponentsPropertiesEvents.SET_ATTRIBUTE_TABLE_ATTRIBUTES:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    attributes: action.payload,
                    loading: false
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_SELECT_ATTRIBUTE_DIALOG:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    showSelectAttributeDialog: !state.attributeTable.showSelectAttributeDialog
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_SYNC_ATTRIBUTE_DIALOG:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    showSyncAttributeDialog: !state.attributeTable.showSyncAttributeDialog
                }
            };
        case ComponentsPropertiesEvents.SET_SYNCED_COMPONENTS_CHANGED:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    isSyncedComponentsChanged: action.payload
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_ATTRIBUTE_HYPERLINK:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    attributes: state.attributeTable.attributes.map(attribute => {
                        if (attribute.id === action.payload) {
                            return {
                                ...attribute,
                                hyperlink: !attribute.hyperlink
                            };
                        }
                        return attribute;
                    })
                }
            };
        case ComponentsPropertiesEvents.SELECT_ATTRIBUTE:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    selectedAttributeId: action.payload
                }
            }
        case ComponentsPropertiesEvents.SET_ATTRIBUTE_TARGET_PAGE:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    attributes: state.attributeTable.attributes.map(attribute => {
                        if (attribute.attributeId === action.payload.attributeId) {
                            return {
                                ...attribute,
                                targetPageId: action.payload.targetPageId
                            };
                        }
                        return attribute;
                    })
                }
            };
        case ComponentsPropertiesEvents.SET_ATTRIBUTE_PROPERTY:
            return {
                ...state,
                attributeTable: {
                    ...state.attributeTable,
                    attributes: state.attributeTable.attributes.map(attribute => {
                        if (attribute.attributeId === action.payload.attributeId) {
                            return {
                                ...attribute,
                                [action.payload.property]: action.payload.value
                            };
                        }
                        return attribute;
                    })
                }
            };
        case ComponentsPropertiesEvents.SET_REFERENCES:
            return {
                ...state,
                referenceTable: {
                    references: action.payload
                }
            };
        case ComponentsPropertiesEvents.SELECT_REFERENCE:
            return {
                ...state,
                referenceTable: {
                    ...state.referenceTable,
                    selectedReferenceId: action.payload
                }
            };
        case ComponentsPropertiesEvents.ADD_REFERENCE_ROW:
            const newEntity = {
                id: "",
                name: "Select " + ENTITY_LABEL,
                pages: [
                    {
                        id: "",
                        pageName: "Select Page",
                    }
                ],
                relations: [
                    {
                        relationId: "",
                        relationName: "Select Relation"
                    }
                ]
            }
            return {
                ...state,
                referenceTable: {
                    ...state.referenceTable,
                    references: [
                        ...state.referenceTable.references,
                        {
                            id: state.referenceTable.references.length + 1,
                            entity: newEntity,
                            page: [],
                            relation: newEntity.relations[0],
                            show: true,
                            isNew: true,
                            pages: []
                        }
                    ]
                }
            };
        case ComponentsPropertiesEvents.UPDATE_REFERENCE_PROPERTY:
            return {
                ...state,
                referenceTable: {
                    ...state.referenceTable,
                    references: state.referenceTable.references.map(reference => {
                        if (reference.id === action.payload.id) {
                            return {
                                ...reference,
                                [action.payload.property]: action.payload.value
                            };
                        }
                        return reference;
                    })
                }
            };
        case ComponentsPropertiesEvents.DELETE_REFERENCE:
            return {
                ...state,
                referenceTable: {
                    ...state.referenceTable,
                    references: state.referenceTable.references.filter(reference => reference.id !== action.payload)
                }
            };
        case ComponentsPropertiesEvents.RESET_CONTEXT:
            return initialState;
        case ComponentsPropertiesEvents.TOGGLE_SAVING:
            return {
                ...state,
                isSaving: !state.isSaving
            };
        case ComponentsPropertiesEvents.TOGGLE_PUBLISHING:
            return {
                ...state,
                isPublishing: !state.isPublishing
            };
        case ComponentsPropertiesEvents.SET_STEPS:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: structuredClone(action.payload),
                    formBuilderLoading: false
                }
            };
        case ComponentsPropertiesEvents.SELECTED_STEP_ID:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    selectedStepId: action.payload
                }
            };
        case ComponentsPropertiesEvents.ADD_STEP:
            const id = uuidv4();
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: [
                        ...state.attributeFormBuilder.steps,
                        {
                            id: id,
                            name: "Step " + (state.attributeFormBuilder.steps.length + 1),
                            layout: [
                                {
                                    id: uuidv4(),
                                    section: "",
                                    columns: []
                                }
                            ],
                            languages: {}
                        }
                    ],
                    selectedStepId: id
                }
            };
        case ComponentsPropertiesEvents.REMOVE_STEP:
            const stepsForRemovingStep = [...state.attributeFormBuilder.steps]
            const stepIndexForRemovingStep = stepsForRemovingStep.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const updatedStepsForRemovingStep = stepsForRemovingStep.filter(step => step.id !== state.attributeFormBuilder.selectedStepId);
            let newSelectedStepId = ""
            if (updatedStepsForRemovingStep.length === 0) {
                newSelectedStepId = ""
            } else if (stepIndexForRemovingStep === 0) {
                newSelectedStepId = updatedStepsForRemovingStep[0].id
            } else {
                newSelectedStepId = updatedStepsForRemovingStep[stepIndexForRemovingStep - 1].id
            }
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: updatedStepsForRemovingStep,
                    selectedStepId: newSelectedStepId
                }
            };
        case ComponentsPropertiesEvents.UPDATE_STEP_NAME:
            const stepsForUpdatingStepName = [...state.attributeFormBuilder.steps]
            const stepIndexForUpdatingStepName = stepsForUpdatingStepName.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForUpdatingStepName = stepsForUpdatingStepName[stepIndexForUpdatingStepName];
            stepForUpdatingStepName.name = action.payload;
            stepsForUpdatingStepName[stepIndexForUpdatingStepName] = stepForUpdatingStepName;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForUpdatingStepName
                }
            };
        case ComponentsPropertiesEvents.UPDATE_STEP_LANGUAGES:
            const stepsForUpdatingStepLanguages = [...state.attributeFormBuilder.steps]
            const stepIndexForUpdatingStepLanguages = stepsForUpdatingStepLanguages.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForUpdatingStepLanguages = stepsForUpdatingStepLanguages[stepIndexForUpdatingStepLanguages];
            stepForUpdatingStepLanguages.languages = action.payload;
            stepsForUpdatingStepLanguages[stepIndexForUpdatingStepLanguages] = stepForUpdatingStepLanguages;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForUpdatingStepLanguages
                }
            };
        case ComponentsPropertiesEvents.SET_FORM_ACTIONS:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    formActions: action.payload
                }
            };
        case ComponentsPropertiesEvents.UPDATE_FORM_ACTION:
            const formActionsForUpdatingFormAction = [...state.attributeFormBuilder.formActions];
            const formActionIndexForUpdatingFormAction = formActionsForUpdatingFormAction.findIndex(formAction => formAction.id === action.payload.id);
            formActionsForUpdatingFormAction[formActionIndexForUpdatingFormAction] = action.payload;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    formActions: formActionsForUpdatingFormAction
                }
            };
        case ComponentsPropertiesEvents.REMOVE_MULTIPLE_STEPS:
            const stepsForRemovingMultipleSteps = [...state.attributeFormBuilder.steps]
            const updatedStepsForRemovingMultipleSteps = stepsForRemovingMultipleSteps.filter(step => step.id === stepsForRemovingMultipleSteps[0].id);
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: updatedStepsForRemovingMultipleSteps,
                    selectedStepId: updatedStepsForRemovingMultipleSteps.length === 0 ? "" : updatedStepsForRemovingMultipleSteps[0].id
                }
            };
        case ComponentsPropertiesEvents.UPDATE_LAYOUT_FROM_RECOMMENDATION:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: [
                        {
                            id: uuidv4(),
                            name: "Step 1",
                            layout: action.payload,
                            languages: {}
                        }
                    ],
                    selectedStepId: 0
                },
            };
        case ComponentsPropertiesEvents.ADD_COLUMN:
            const stepsForAddingColumn = [...state.attributeFormBuilder.steps]
            const stepIndexForAddingColumn = stepsForAddingColumn.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForAddingColumn = stepsForAddingColumn[stepIndexForAddingColumn];
            const layoutForAddingColumn = stepForAddingColumn.layout.slice();
            const updatedLayoutForAddingColumn = addColumn(
                layoutForAddingColumn,
                action.payload.columns,
                action.payload.dropSectionId,
                action.payload.draggedAttribute,
                action.payload.componentType
            );
            stepForAddingColumn.layout = updatedLayoutForAddingColumn;
            stepsForAddingColumn[stepIndexForAddingColumn] = stepForAddingColumn;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForAddingColumn
                }
            };
        case ComponentsPropertiesEvents.REMOVE_COLUMN:
            const stepsForRemovingColumn = [...state.attributeFormBuilder.steps]
            const stepIndexForRemovingColumn = stepsForRemovingColumn.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForRemovingColumn = stepsForRemovingColumn[stepIndexForRemovingColumn];
            const layoutForRemovingColumn = stepForRemovingColumn.layout.slice();
            const updatedLayoutForRemovingColumn = removeColumn(layoutForRemovingColumn, action.payload);
            stepForRemovingColumn.layout = updatedLayoutForRemovingColumn;
            stepsForRemovingColumn[stepIndexForRemovingColumn] = stepForRemovingColumn;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForRemovingColumn
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_COLUMN_HYPERLINK:
            const stepsForTogglingColumnHyperlink = [...state.attributeFormBuilder.steps]
            const stepIndexForTogglingColumnHyperlink = stepsForTogglingColumnHyperlink.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForTogglingColumnHyperlink = stepsForTogglingColumnHyperlink[stepIndexForTogglingColumnHyperlink];
            const layoutForTogglingColumnHyperlink = stepForTogglingColumnHyperlink.layout.slice();
            const updatedLayoutForTogglingColumnHyperlink = toggleColumnHyperlink(
                layoutForTogglingColumnHyperlink,
                action.payload.attributeId,
                action.payload.hyperlink,
                action.payload.targetPageId
            )
            stepForTogglingColumnHyperlink.layout = updatedLayoutForTogglingColumnHyperlink;
            stepsForTogglingColumnHyperlink[stepIndexForTogglingColumnHyperlink] = stepForTogglingColumnHyperlink;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForTogglingColumnHyperlink
                }
            };
        case ComponentsPropertiesEvents.TOGGLE_COLUMN_COLOR_FORMATTING:
            const stepsForTogglingColumnColorFormatting = [...state.attributeFormBuilder.steps]
            const stepIndexForTogglingColumnColorFormatting = stepsForTogglingColumnColorFormatting.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForTogglingColumnColorFormatting = stepsForTogglingColumnColorFormatting[stepIndexForTogglingColumnColorFormatting];
            const layoutForTogglingColumnColorFormatting = stepForTogglingColumnColorFormatting.layout.slice();
            const updatedLayoutForTogglingColumnColorFormatting = toggleColumnColorFormatting(
                layoutForTogglingColumnColorFormatting,
                action.payload.attributeId,
                action.payload.cellRules
            )
            stepForTogglingColumnColorFormatting.layout = updatedLayoutForTogglingColumnColorFormatting;
            stepsForTogglingColumnColorFormatting[stepIndexForTogglingColumnColorFormatting] = stepForTogglingColumnColorFormatting;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForTogglingColumnColorFormatting
                }
            };
        case ComponentsPropertiesEvents.DROP_COLUMN_IN_SAME_SECTION:
            const stepsForDroppingColumnInSameSection = [...state.attributeFormBuilder.steps]
            const stepIndexForDroppingColumnInSameSection = stepsForDroppingColumnInSameSection.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForDroppingColumnInSameSection = stepsForDroppingColumnInSameSection[stepIndexForDroppingColumnInSameSection];
            const layoutForDroppingColumnInSameSection = stepForDroppingColumnInSameSection.layout.slice();
            const updatedDropLayoutInSameSection = dropColumnInSameSection(
                layoutForDroppingColumnInSameSection,
                action.payload.columns,
                action.payload.dropSectionId,
                action.payload.draggedColumn
            );
            stepForDroppingColumnInSameSection.layout = updatedDropLayoutInSameSection;
            stepsForDroppingColumnInSameSection[stepIndexForDroppingColumnInSameSection] = stepForDroppingColumnInSameSection;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForDroppingColumnInSameSection
                }
            };
        case ComponentsPropertiesEvents.DROP_COLUMN_IN_DIFFERENT_SECTION:
            const stepsForDroppingColumnInDifferentSection = [...state.attributeFormBuilder.steps]
            const stepIndexForDroppingColumnInDifferentSection = stepsForDroppingColumnInDifferentSection.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForDroppingColumnInDifferentSection = stepsForDroppingColumnInDifferentSection[stepIndexForDroppingColumnInDifferentSection];
            const layoutForDroppingColumnInDifferentSection = stepForDroppingColumnInDifferentSection.layout.slice();
            const updatedDropLayoutInDifferentSection = dropColumnInDifferentSection(
                layoutForDroppingColumnInDifferentSection,
                action.payload.columns,
                action.payload.dragSectionId,
                action.payload.dropSectionId,
                action.payload.draggedColumn
            );
            stepForDroppingColumnInDifferentSection.layout = updatedDropLayoutInDifferentSection;
            stepsForDroppingColumnInDifferentSection[stepIndexForDroppingColumnInDifferentSection] = stepForDroppingColumnInDifferentSection;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForDroppingColumnInDifferentSection
                }
            };
        case ComponentsPropertiesEvents.RESIZE_COLUMNS:
            const stepsForResizingColumns = [...state.attributeFormBuilder.steps]
            const stepIndexForResizingColumns = stepsForResizingColumns.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForResizingColumns = stepsForResizingColumns[stepIndexForResizingColumns];
            const layoutForResizingColumns = stepForResizingColumns.layout.slice();
            const updatedLayoutForResizingColumns = resizeColumns(
                layoutForResizingColumns,
                action.payload.sectionId,
                action.payload.columns
            );
            stepForResizingColumns.layout = updatedLayoutForResizingColumns;
            stepsForResizingColumns[stepIndexForResizingColumns] = stepForResizingColumns;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForResizingColumns
                }
            };
        case ComponentsPropertiesEvents.ADD_SECTION:
            const stepsForAddingSection = [...state.attributeFormBuilder.steps]
            const stepIndexForAddingSection = stepsForAddingSection.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForAddingSection = stepsForAddingSection[stepIndexForAddingSection];
            const layoutForAddingSection = stepForAddingSection.layout.slice();
            const updatedLayoutForAddingSection = [
                {
                    id: uuidv4(),
                    section: "",
                    languages: {},
                    columns: []
                },
                ...layoutForAddingSection,
            ];
            stepForAddingSection.layout = updatedLayoutForAddingSection;
            stepsForAddingSection[stepIndexForAddingSection] = stepForAddingSection;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForAddingSection
                }
            };
        case ComponentsPropertiesEvents.REMOVE_SECTION:
            const stepsForRemovingSection = [...state.attributeFormBuilder.steps]
            const stepIndexForRemovingSection = stepsForRemovingSection.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForRemovingSection = stepsForRemovingSection[stepIndexForRemovingSection];
            const layoutForRemovingSection = stepForRemovingSection.layout.slice();
            const updatedLayoutForRemovingSection = layoutForRemovingSection.filter(section => section.id !== action.payload);
            stepForRemovingSection.layout = updatedLayoutForRemovingSection;
            stepsForRemovingSection[stepIndexForRemovingSection] = stepForRemovingSection;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForRemovingSection
                }
            };
        case ComponentsPropertiesEvents.MOVE_SECTION_UP:
            const stepsForMovingSectionUp = [...state.attributeFormBuilder.steps]
            const stepIndexForMovingSectionUp = stepsForMovingSectionUp.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForMovingSectionUp = stepsForMovingSectionUp[stepIndexForMovingSectionUp];
            const layoutForMovingSectionUp = stepForMovingSectionUp.layout.slice();
            const updatedLayoutforMovingSectionUp = moveSectionUp(layoutForMovingSectionUp, action.payload);
            stepForMovingSectionUp.layout = updatedLayoutforMovingSectionUp;
            stepsForMovingSectionUp[stepIndexForMovingSectionUp] = stepForMovingSectionUp;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForMovingSectionUp
                }
            };
        case ComponentsPropertiesEvents.MOVE_SECTION_DOWN:
            const stepsForMovingSectionDown = [...state.attributeFormBuilder.steps]
            const stepIndexForMovingSectionDown = stepsForMovingSectionDown.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForMovingSectionDown = stepsForMovingSectionDown[stepIndexForMovingSectionDown];
            const layoutForMovingSectionDown = stepForMovingSectionDown.layout.slice();
            const updatedLayoutforMovingSectionDown = moveSectionDown(layoutForMovingSectionDown, action.payload);
            stepForMovingSectionDown.layout = updatedLayoutforMovingSectionDown;
            stepsForMovingSectionDown[stepIndexForMovingSectionDown] = stepForMovingSectionDown;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForMovingSectionDown
                }
            };
        case ComponentsPropertiesEvents.UPDATE_SECTION_NAME:
            const stepsForUpdatingSectionName = [...state.attributeFormBuilder.steps]
            const stepIndexForUpdatingSectionName = stepsForUpdatingSectionName.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForUpdatingSectionName = stepsForUpdatingSectionName[stepIndexForUpdatingSectionName];
            const layoutForUpdatingSectionName = stepForUpdatingSectionName.layout.slice();
            const updatedLayoutForUpdatingSectionName = layoutForUpdatingSectionName.map(section => {
                if (section.id === action.payload.sectionId) {
                    return {
                        ...section,
                        section: action.payload.section
                    };
                }
                return section;
            });
            stepForUpdatingSectionName.layout = updatedLayoutForUpdatingSectionName;
            stepsForUpdatingSectionName[stepIndexForUpdatingSectionName] = stepForUpdatingSectionName;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForUpdatingSectionName
                }
            };

        case ComponentsPropertiesEvents.UPDATE_SECTION_LANGUAGES:
            const stepsForUpdatingSectionLanguages = [...state.attributeFormBuilder.steps]
            const stepIndexForUpdatingSectionLanguages = stepsForUpdatingSectionLanguages.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForUpdatingSectionLanguages = stepsForUpdatingSectionLanguages[stepIndexForUpdatingSectionLanguages];
            const layoutForUpdatingSectionLanguages = stepForUpdatingSectionLanguages.layout.slice();
            const updatedLayoutForUpdatingSectionLanguages = layoutForUpdatingSectionLanguages.map(section => {
                if (section.id === action.payload.sectionId) {
                    return {
                        ...section,
                        languages: action.payload.languages
                    };
                }
                return section;
            });
            stepForUpdatingSectionLanguages.layout = updatedLayoutForUpdatingSectionLanguages;
            stepsForUpdatingSectionLanguages[stepIndexForUpdatingSectionLanguages] = stepForUpdatingSectionLanguages;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForUpdatingSectionLanguages
                }
            };

        case ComponentsPropertiesEvents.SET_FORM_BUILDER_ATTRIBUTES:
            return {
                ...state,
                formBuilderAttributes: {
                    ...state.formBuilderAttributes,
                    attributes: action.payload,
                    loading: false
                }
            };

        case ComponentsPropertiesEvents.UPDATE_FORM_BUILDER_ATTRIBUTE_PROPERTY:
            return {
                ...state,
                formBuilderAttributes: {
                    ...state.formBuilderAttributes,
                    attributes: state.formBuilderAttributes.attributes.map(attribute =>
                        attribute.attributeId === action.payload.attributeId
                            ? { ...attribute, [action.payload.property]: action.payload.value }
                            : attribute
                    )
                }
            };

        case ComponentsPropertiesEvents.SELECT_FORM_BUILDER_ATTRIBUTE:
            return {
                ...state,
                formBuilderAttributes: {
                    ...state.formBuilderAttributes,
                    selectedAttributeId: action.payload
                }
            };

        case ComponentsPropertiesEvents.TOGGLE_FORM_BUILDER_SYNC_ATTRIBUTE_DIALOG:
            return {
                ...state,
                formBuilderAttributes: {
                    ...state.formBuilderAttributes,
                    showSyncAttributeDialog: !state.formBuilderAttributes.showSyncAttributeDialog
                }
            };

        case ComponentsPropertiesEvents.TOGGLE_EDIT_COLUMN_PANEL:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    showEditColumnPanel: !state.attributeFormBuilder.showEditColumnPanel
                }
            };

        case ComponentsPropertiesEvents.SET_EDITING_COLUMN:
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    editingColumn: action.payload
                }
            };

        case ComponentsPropertiesEvents.UPDATE_COLUMN_SETTINGS:
            const stepsForUpdatingColumnSettings = [...state.attributeFormBuilder.steps];
            const stepIndexForUpdatingColumnSettings = stepsForUpdatingColumnSettings.findIndex(step => step.id === state.attributeFormBuilder.selectedStepId);
            const stepForUpdatingColumnSettings = stepsForUpdatingColumnSettings[stepIndexForUpdatingColumnSettings];
            const layoutForUpdatingColumnSettings = stepForUpdatingColumnSettings.layout.slice();
            const updatedLayoutForUpdatingColumnSettings = updateColumnSettings(layoutForUpdatingColumnSettings, action.payload.attributeId, action.payload.columnSettings);
            stepForUpdatingColumnSettings.layout = updatedLayoutForUpdatingColumnSettings;
            stepsForUpdatingColumnSettings[stepIndexForUpdatingColumnSettings] = stepForUpdatingColumnSettings;
            return {
                ...state,
                attributeFormBuilder: {
                    ...state.attributeFormBuilder,
                    steps: stepsForUpdatingColumnSettings
                }
            };

        case ComponentsPropertiesEvents.SET_VALIDATION_ERRORS:
            return {
                ...state,
                validation: {
                    hasErrors: Object.keys(action.payload).length > 0,
                    errors: action.payload
                }
            };
        case ComponentsPropertiesEvents.CLEAR_VALIDATION_ERRORS:
            return {
                ...state,
                validation: {
                    hasErrors: false,
                    errors: {}
                }
            };
        default:
            return state;
    }
}